import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"; // this is needed!
import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CurrencyPipe, DecimalPipe } from "@angular/common";

import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { RoutesModule } from "./routes/routes.module";
import { LayoutModule } from "./layout/layout.module";
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from "ngx-google-analytics";
import { ServiceWorkerModule } from "@angular/service-worker";
import { AuthenticationService, EnvironmentConfig } from "@rubbl-core";
import { NgxMaskModule } from "ngx-mask";

import { ApiUnauthorizedInterceptor } from "./core/api-unauthorized.interceptor";

declare let environment: EnvironmentConfig;

const onProd = window.location.hostname == "rubbl.com" || window.location.hostname == "www.rubbl.com";

let gtmProvider = { provide: "googleTagManagerId", useValue: "GTM-fake-one" };
if (onProd) {
  gtmProvider = { provide: "googleTagManagerId", useValue: "GTM-WD8K79F" };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    SharedModule.forRoot(),
    LayoutModule,
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsId),
    NgxGoogleAnalyticsRouterModule, // https://www.npmjs.com/package/ngx-google-analytics#setup-routing-module
    RoutesModule, // this needs to last, but before the service worker, otherwise we will get blank white page
    ServiceWorkerModule.register("./ngsw-worker.js", {
      enabled: window.location.hostname != "localhost",
      registrationStrategy: "registerImmediately",
    }),
  ],
  providers: [
    CurrencyPipe,
    DecimalPipe,
    AuthenticationService,
    gtmProvider,
    { provide: HTTP_INTERCEPTORS, useClass: ApiUnauthorizedInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
